import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeftOutlined,
  TeamOutlined,
  FileTextOutlined,
  ProfileOutlined,
  SolutionOutlined,
  ExperimentOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DollarOutlined,
} from "@ant-design/icons";

import "./companyAnalytics.scss";
import superUseStatsStore from "../../../store/superuser.store";

export default function CompanyAnalytics() {
  const { superUserCompanyAnalytics,getSuperUserCompanyAnalytics} = superUseStatsStore();  
  const navigate = useNavigate();
  const { qhoid } = useParams();
  useEffect(() => {
      getSuperUserCompanyAnalytics("All",qhoid);
  }, []);  

  const getInfo =() =>{
    if(superUserCompanyAnalytics?.productsigon){

    }
  }
  // ----------------------------------------------------
  // Replace this with API response later
  // GET /admin/company/:qhoid/analytics
  // ----------------------------------------------------
  const companyAnalytics = {
    company: {
      name: superUserCompanyAnalytics?.companyName,
      qhoid: "QHO123456",
      planName: "QHRFlow Growth",
      subscriptionStatus: "ACTIVE",
      customerSince: superUserCompanyAnalytics?.createdon,
      billingCycle: "Yearly",
      subscriptionStart: "01-Apr-2026",
      subscriptionEnd: "31-Mar-2027",
      nextRenewal: "31-Mar-2027",
    },

    stats: {
      users: superUserCompanyAnalytics?.users,
      jobs: superUserCompanyAnalytics?.jobs,
      activeJobs: 17,
      resumes: superUserCompanyAnalytics?.resumes,
      applications: superUserCompanyAnalytics?.applications,
      evaluations: superUserCompanyAnalytics?.evaluations,
      nujusers: superUserCompanyAnalytics?.nujusers,
      totalPayment: 0,
    },

    planUsage: {
      users: {
        used: 8,
        limit: 10,
      },
      jobs: {
        used: 17,
        limit: 20,
      },
      resumes: {
        used: 3450,
        limit: 5000,
      },
      emails: {
        used: 7820,
        limit: 10000,
      },
    },

    funnel: [
      {
        label: "Resumes",
        value: superUserCompanyAnalytics?.resumes,
      },
      {
        label: "Applications",
        value: superUserCompanyAnalytics?.applications,
      },
      {
        label: "Resume Suitable",
        value: superUserCompanyAnalytics?.hiringfunnelstruct?.resumeSuitable,
      },
      {
        label: "Available",
        value: superUserCompanyAnalytics?.hiringfunnelstruct?.available,
      },
      {
        label: "Interviewed",
        value: superUserCompanyAnalytics?.hiringfunnelstruct?.interviewed,
      },      
      {
        label: "Selected",
        value: superUserCompanyAnalytics?.hiringfunnelstruct?.selected,
      },
      {
        label: "Joined",
        value: superUserCompanyAnalytics?.hiringfunnelstruct?.joined,
      },
    ],

    recruiters: [
      {
        name: "Rahul",
        jobs: 8,
        resumes: 540,
        applications: 210,
        interviews: 46,
        selections: 8,
      },
      {
        name: "Priya",
        jobs: 12,
        resumes: 820,
        applications: 330,
        interviews: 71,
        selections: 14,
      },
      {
        name: "Amit",
        jobs: 6,
        resumes: 390,
        applications: 142,
        interviews: 29,
        selections: 5,
      },
    ],

    payments: [
      {
        invoice: "INV-2026-001",
        date: "01-Apr-2026",
        description: "QHRFlow Growth - Yearly",
        amount: 24000,
        status: "PAID",
      },
      {
        invoice: "INV-2026-014",
        date: "10-May-2026",
        description: "Additional Users",
        amount: 4194,
        status: "PAID",
      },
      {
        invoice: "INV-2026-025",
        date: "18-Jun-2026",
        description: "Additional JDs",
        amount: 2388,
        status: "PAID",
      },
    ],
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-IN").format(number || 0);
  };

  const formatCurrency = (number) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(number || 0);
  };

  const getPercentage = (used, limit) => {
    if (!limit) return 0;

    return Math.min(Math.round((used / limit) * 100), 100);
  };

  const StatCard = ({ icon, title, value, subValue }) => {
    return (
      <div className="companyAnalytics-stat-card">
        <div className="companyAnalytics-stat-icon">{icon}</div>

        <div className="companyAnalytics-stat-content">
          <div className="companyAnalytics-stat-title">{title}</div>

          <div className="companyAnalytics-stat-value">{value}</div>

          {subValue && (
            <div className="companyAnalytics-stat-subvalue">
              {subValue}
            </div>
          )}
        </div>
      </div>
    );
  };

  const UsageBar = ({ title, used, limit }) => {
    const percentage = getPercentage(used, limit);

    return (
      <div className="companyAnalytics-usage-item">
        <div className="companyAnalytics-usage-header">
          <span>{title}</span>

          <span>
            {formatNumber(used)} / {formatNumber(limit)}
          </span>
        </div>

        <div className="companyAnalytics-progress">
          <div
            className="companyAnalytics-progress-fill"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <div className="companyAnalytics-progress-percentage">
          {percentage}% used
        </div>
      </div>
    );
  };

  return (
    <div className="companyAnalytics-wrapper">

      {/* =====================================================
          HEADER
      ====================================================== */}

      <div className="companyAnalytics-header">

        <div className="companyAnalytics-header-left">
          <button
            className="companyAnalytics-back-btn"
            onClick={() => navigate(-1)}
          >
            <ArrowLeftOutlined />
          </button>

          <div>
            <div className="companyAnalytics-company-name">
              {companyAnalytics.company.name}
            </div>

            <div className="companyAnalytics-company-id">
              Company ID: {companyAnalytics.company.qhoid}
            </div>
          </div>
        </div>

        <div className="companyAnalytics-header-right">

          <div className="companyAnalytics-plan">
            {companyAnalytics.company.planName}
          </div>

          <div
            className={`companyAnalytics-status ${
              companyAnalytics.company.subscriptionStatus === "ACTIVE"
                ? "active"
                : "inactive"
            }`}
          >
            {companyAnalytics.company.subscriptionStatus}
          </div>

        </div>
      </div>

      <div className="companyAnalytics-customer-since">
        Customer Since: {companyAnalytics.company.customerSince}
      </div>

      {/* =====================================================
          TOP KPI CARDS
      ====================================================== */}

      <div className="companyAnalytics-stats-grid">

        <StatCard
          icon={<TeamOutlined />}
          title="Users"
          value={formatNumber(companyAnalytics.stats.users)}
        />

        <StatCard
          icon={<FileTextOutlined />}
          title="Jobs"
          value={formatNumber(companyAnalytics.stats.jobs)}
          subValue={`${companyAnalytics.stats.activeJobs} Active`}
        />

        <StatCard
          icon={<ProfileOutlined />}
          title="Resumes"
          value={formatNumber(companyAnalytics.stats.resumes)}
        />

        <StatCard
          icon={<SolutionOutlined />}
          title="Applications"
          value={formatNumber(companyAnalytics.stats.applications)}
        />

        <StatCard
          icon={<ExperimentOutlined />}
          title="Evaluations"
          value={formatNumber(companyAnalytics.stats.evaluations)}
        />

        <StatCard
          icon={<CalendarOutlined />}
          title="Nuj Users"
          value={formatNumber(companyAnalytics.stats.interviews)}
        />

        <StatCard
          icon={<DollarOutlined />}
          title="Total Payments"
          value={formatCurrency(companyAnalytics.stats.totalPayment)}
        />

      </div>

      {/* =====================================================
          FUNNEL + PLAN UTILIZATION
      ====================================================== */}

      <div className="companyAnalytics-two-column">

        {/* Hiring Funnel */}

        <div className="companyAnalytics-section">

          <div className="companyAnalytics-section-title">
            Hiring Funnel
          </div>

          <div className="companyAnalytics-funnel">

            {companyAnalytics.funnel.map((item, index) => (
              <React.Fragment key={item.label}>

                <div className="companyAnalytics-funnel-item">

                  <div className="companyAnalytics-funnel-label">
                    {item.label}
                  </div>

                  <div className="companyAnalytics-funnel-value">
                    {formatNumber(item.value)}
                  </div>

                </div>

                {index !== companyAnalytics.funnel.length - 1 && (
                  <div className="companyAnalytics-funnel-arrow">
                    ↓
                  </div>
                )}

              </React.Fragment>
            ))}

          </div>

        </div>

        {/* Plan Utilization */}

        <div className="companyAnalytics-section">

          <div className="companyAnalytics-section-title">
            Plan Utilization
          </div>

          <UsageBar
            title="Users"
            {...companyAnalytics.planUsage.users}
          />

          <UsageBar
            title="Active Jobs"
            {...companyAnalytics.planUsage.jobs}
          />

          <UsageBar
            title="Resumes"
            {...companyAnalytics.planUsage.resumes}
          />

          <UsageBar
            title="Emails"
            {...companyAnalytics.planUsage.emails}
          />

        </div>

      </div>

      {/* =====================================================
          RECRUITER PERFORMANCE
      ====================================================== */}

      <div className="companyAnalytics-section">

        <div className="companyAnalytics-section-title">
          Recruiter Performance
        </div>

        <div className="companyAnalytics-table-wrapper">

          <table className="companyAnalytics-table">

            <thead>
              <tr>
                <th>Recruiter</th>
                <th>Jobs</th>
                <th>Resumes</th>
                <th>Applications</th>
                <th>Interviews</th>
                <th>Selections</th>
              </tr>
            </thead>

            <tbody>

              {companyAnalytics.recruiters.map((recruiter) => (
                <tr key={recruiter.name}>

                  <td className="companyAnalytics-recruiter-name">
                    {recruiter.name}
                  </td>

                  <td>{formatNumber(recruiter.jobs)}</td>

                  <td>{formatNumber(recruiter.resumes)}</td>

                  <td>{formatNumber(recruiter.applications)}</td>

                  <td>{formatNumber(recruiter.interviews)}</td>

                  <td>{formatNumber(recruiter.selections)}</td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

      {/* =====================================================
          SUBSCRIPTION
      ====================================================== */}

      <div className="companyAnalytics-two-column">

        <div className="companyAnalytics-section">

          <div className="companyAnalytics-section-title">
            Subscription
          </div>

          <div className="companyAnalytics-info-row">
            <span>Plan</span>
            <strong>{companyAnalytics.company.planName}</strong>
          </div>

          <div className="companyAnalytics-info-row">
            <span>Billing Cycle</span>
            <strong>{companyAnalytics.company.billingCycle}</strong>
          </div>

          <div className="companyAnalytics-info-row">
            <span>Subscription Start</span>
            <strong>{companyAnalytics.company.subscriptionStart}</strong>
          </div>

          <div className="companyAnalytics-info-row">
            <span>Subscription End</span>
            <strong>{companyAnalytics.company.subscriptionEnd}</strong>
          </div>

          <div className="companyAnalytics-info-row">
            <span>Next Renewal</span>
            <strong>{companyAnalytics.company.nextRenewal}</strong>
          </div>

          <div className="companyAnalytics-info-row">
            <span>Status</span>

            <strong className="companyAnalytics-active-text">
              {companyAnalytics.company.subscriptionStatus}
            </strong>
          </div>

        </div>

        {/* Revenue */}

        <div className="companyAnalytics-section">

          <div className="companyAnalytics-section-title">
            Revenue Summary
          </div>

          <div className="companyAnalytics-revenue-highlight">

            <div>Total Revenue</div>

            <strong>
              {formatCurrency(companyAnalytics.stats.totalPayment)}
            </strong>

          </div>

          <div className="companyAnalytics-revenue-grid">

            <div>
              <span>Amount Paid</span>
              <strong>
                {formatCurrency(companyAnalytics.stats.totalPayment)}
              </strong>
            </div>

            <div>
              <span>Outstanding</span>
              <strong>{formatCurrency(0)}</strong>
            </div>

          </div>

        </div>

      </div>

      {/* =====================================================
          PAYMENT HISTORY
      ====================================================== */}

      <div className="companyAnalytics-section">

        <div className="companyAnalytics-section-title">
          Payment History
        </div>

        <div className="companyAnalytics-table-wrapper">

          <table className="companyAnalytics-table">

            <thead>
              <tr>
                <th>Invoice</th>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>

              {companyAnalytics.payments.map((payment) => (
                <tr key={payment.invoice}>

                  <td>{payment.invoice}</td>

                  <td>{payment.date}</td>

                  <td>{payment.description}</td>

                  <td>
                    {formatCurrency(payment.amount)}
                  </td>

                  <td>
                    <span className="companyAnalytics-payment-paid">
                      {payment.status}
                    </span>
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}